define.alias("ember-power-select/components/power-select/placeholder", "settings/components/power-select/placeholder");